import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {CircularProgress} from '@mui/material';
import {isAuthRedirectError} from '../../../shared/services/auth.service';
import {logError} from '../../../shared/services/logger.service';
import {RecordMessage} from '../../../shared/components/record/RecordKit';
import {getWorkOrder} from '../../work-order/work-order.service';
import EstimateRecordPage from './EstimateRecordPage';

/*
 * A job's own page (/jobs/12, SQ-597): the job is the estimate's page once
 * the estimate is approved, so this finds the estimate the work order was
 * made from and opens the record as that job.
 */
const JobRecordPage = ({workOrderId, onChanged}: {workOrderId: number; onChanged?: () => void}) => {
  const navigate = useNavigate();
  const [estimateId, setEstimateId] = useState<number>();
  const [error, setError] = useState<string>();
  useEffect(() => {
    let active = true;
    getWorkOrder(navigate, workOrderId)
      .then(found => active && setEstimateId(found.estimateId))
      .catch(e => {
        if (!active || isAuthRedirectError(e)) return;
        logError('Error getting the job', {workOrderId}, e as Error);
        setError(`Couldn't load this job: ${e}`);
      });
    return () => { active = false; };
  }, [navigate, workOrderId]);
  if (error) return <RecordMessage error text={error}/>;
  if (estimateId === undefined) return <CircularProgress/>;
  return <EstimateRecordPage estimateId={estimateId} workOrderId={workOrderId} onChanged={onChanged}/>;
};

export default JobRecordPage;
